const timeoutPromise = ms => new Promise(resolve => setTimeout(resolve, ms));

export default timeoutPromise;
